import { Authenticationservice } from './../../services/authentication.service';
import { Component, Input, OnInit } from '@angular/core';
import axios from 'axios';

import * as CanvasJS from '../../../supporter/canvasjs.min.js';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.css']
})
export class MyprofileComponent implements OnInit {
  @Input() supcode;
  userdata: any[];
  formedit: UntypedFormGroup;
  submitted = false;
  constructor(private auth: Authenticationservice, private storage: AngularFireStorage) {
    let lebdata: any;
    lebdata = this.auth.Authention();
    this.userdata = new Array(lebdata);
    this.supcode = lebdata.supcode;
    this.formedit = new UntypedFormGroup({
      oldpassword: new UntypedFormControl('', Validators.required),
      newpassword: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(10)
      ]),
      confirmpassword: new UntypedFormControl('', Validators.required),
      oldphone: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(10)
      ]),
      newphone: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10)
      ]),
    });
  }


  ngOnInit(): void {
    /*setTimeout(() => {
      this.Mychart();
    }, 15000);*/

  }

  // testdata:any;
  // LoadTESTDATA(){
  //   axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_Users_w?supcode=%27948%27")
  //   .then(res => {
  //     this.testdata =res.data.recordset;
  //     this.userdata = this.testdata;
  //     this.supcode = this.testdata[0].supcode;
  //   }).catch(err => { throw(err) })
  // }

  Mychart() {

    // console.log(this.chart)
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/targetArea6465';
    axios.get(url)
      .then((out: any) => {
        const data = out.recordsets[0];
        let chartsup = data.filter(element => element.supcode == this.supcode)
        let MyArea = new CanvasJS.Chart("MyArea", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงพื้นที่ปลูกอ้อย",

          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartsup[0].pc_target_areas, name: "พื้นที่ปลูกทั้งหมด", legendText: "พื้นที่ปลูกทั้งหมด :" + chartsup[0].target_areas + " ไร่", color: "#43AA8B" },
              { y: 100 - chartsup[0].pc_target_areas, name: "พื้นที่ปลูกที่ขาด", color: "#FF3333" },

            ]
          }]
        });

        let MyTon = new CanvasJS.Chart("MyTon", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงประเมินอ้อยอ้อย",

          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartsup[0].pc_target_ton, name: "ประเมินอ้อยทั้งหมด", legendText: "ประเมิน :" + chartsup[0].target_ton + " ตัน", color: "#43AA8B" },
              { y: 100 - chartsup[0].pc_target_ton, name: "ประเมินอ้อยที่ขาด", color: "#FF3333" },

            ]
          }]
        });

        let MyYield = new CanvasJS.Chart("MyYield", {
          theme: "light2",
          animationEnabled: true,
          exportEnabled: true,

          title: {
            fontSize: 20,
            labelTextAlign: "center",
            fontFamily: "Sarabun, sans-serif",
            text: "กราฟแสดงค่า Yield อ้อย",

          },
          data: [{
            type: "doughnut",
            showInLegend: true,
            fontFamily: "Sarabun, sans-serif",
            toolTipContent: "<b>{name}</b>: {y} (#percent%)",
            indexLabel: "{name} - #percent%",
            dataPoints: [
              { y: chartsup[0].pc_target_yield, name: "Yield ทั้งหมด", color: "#43AA8B" },
              { y: 100 - chartsup[0].pc_target_yield, name: "Yield ที่ขาด", color: "#FF3333" },
            ]
          }]
        });

        MyArea.render();
        MyTon.render();
        MyYield.render();
      })
      .catch(err => { throw err });
  }
  get form() { return this.formedit.controls; }
  tabactive = 'tab1';
  changepassword = false;
  changephonenumber = true;
  changeprofilepic = true;
  changetabeditdata(id: any) {

    if (id == 1) {
      this.tabactive = 'tab1';
      this.changepassword = false;
      this.changephonenumber = true;
      this.changeprofilepic = true;
    }
    else if (id == 2) {
      this.tabactive = 'tab2';
      this.changepassword = true;
      this.changephonenumber = false;
      this.changeprofilepic = true;
    }
    else if (id == 3) {
      this.tabactive = 'tab3';
      this.changepassword = true;
      this.changephonenumber = true;
      this.changeprofilepic = false;
    }
  }

  onReset(): void {
    this.submitted = false;
    this.formedit.reset();
  }

  forwardpicurl: any;
  onFileUpload(event: any): void {
    var files = event.target.files[0];
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/photos/sup_profile/${this.supcode}/${files.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, files);
    this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
              // const photo: Photo = { url };
              // console.log(url);
              // this.urlimg = = url;
              // this.firestore.collection('photos').doc(this.truckq).set(photo);
            });
        })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/photos/sup_profile/' + this.supcode + '/' + files.name;
    console.log(url_pubilc);
    this.forwardpicurl = url_pubilc;
  }

  editprofirepic() {
    // https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_pic_url_supcode?suppic_url=https://brr-smartfarm.web.app/%23/askformoney&supcode=948
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_pic_url_supcode?"
      + "suppic_url=" + this.forwardpicurl
      + "&supcode=" + this.supcode;
    console.log(url);
    axios.post(url)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
          this.formedit.reset();
        }
        else { alert("บันทึกข้อมูลล้มเหลว"); }
      }).catch(err => { throw (err) });
  }

  editpassword() {
    this.submitted = true;
    let newpassword = this.formedit.get('newpassword')?.value;
    let cfpassword = this.formedit.get('confirmpassword')?.value;
    if (newpassword == null || newpassword == undefined) { alert("กรุณาระบุรหัสผ่าน"); }
    else if (cfpassword != newpassword) { alert("รหัสผ่านใหม่ไม่ตรงกัน"); }
    else {
      // https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/change_pass_supcode?pass=123456948
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/change_pass_supcode?pass=" + newpassword + "&supcode=" + this.supcode;
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
            this.formedit.reset();
          }
          else { alert("บันทึกข้อมูลล้มเหลว"); }
        }).catch(err => { throw (err) })
    }

  }

  editphonenumber() {
    this.submitted = true;
    let newtel = this.formedit.get('newphone')?.value;
    // https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_tel_supcode?tel=044659305&supcode=948
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_tel_supcode?supcode=" + this.supcode + "&tel=" + newtel;

    if (newtel == null || newtel == undefined || newtel == '') {
      alert("กรุณากรอกเบอร์โทรก่อนบันทึกค่ะ");
    }

    else {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
            this.formedit.reset();
          }
          else { alert("บันทึกข้อมูลล้มเหลว"); }
        }).catch(err => { throw (err) })
    }

  }

  editzone() {
    let url = "";
    // axios.post(url)
    // .then(res => {
    //   if (res.data.rowsAffected[0] == 1) {
    //     alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
    //     this.formedit.reset();
    //   }
    //   else { alert("บันทึกข้อมูลล้มเหลว"); }
    // }).catch(err => { throw(err) });
  }
}
